/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import ReactDOM from "react-dom";
import BasicUtils from "../utils/basic-utils";

var getDOMProperties = function getDOMProperties(ref) {
  if (ref == null) {
    ref = {};
  }

  var node = ref.tagName ? // raw DOM node or react 0.15 react ref
  ref : ref.jquery ? // jquery wrapped node
  ref[0] : ReactDOM.findDOMNode(ref);

  var _node$getBoundingClie = node.getBoundingClientRect(),
      top = _node$getBoundingClie.top,
      left = _node$getBoundingClie.left,
      height = _node$getBoundingClie.height,
      width = _node$getBoundingClie.width;

  return {
    left: left,
    top: top,
    height: height,
    width: width,
    scrollTop: node.scrollTop
  };
};

var checkWindowHeightOverflow = function checkWindowHeightOverflow(ref) {
  if (ref != null) {
    var dom_props = getDOMProperties(ref);
    var window_height = window.innerHeight;
    return dom_props.top + dom_props.height > window_height;
  }
};

var checkWindowWidthOverflow = function checkWindowWidthOverflow(ref) {
  if (ref != null) {
    var dom_props = getDOMProperties(ref);
    var window_width = window.innerWidth;
    return dom_props.left + dom_props.width > window_width;
  }
};

var calcHeight = function calcHeight(ref, options) {
  if (options == null) {
    options = {};
  }

  var min = options.min || 0;
  var max = options.max || 100000;

  if (ref != null) {
    var window_height = window.innerHeight;
    var dom_props = getDOMProperties(ref);
    return BasicUtils.getValueWithinRange(window_height - dom_props.top, min, max);
  }
};

var calcWidth = function calcWidth(ref, options) {
  if (options == null) {
    options = {};
  }

  var min = options.min || 0;
  var max = options.max || 100000;

  if (ref != null) {
    var window_width = window.innerWidth;
    var dom_props = getDOMProperties(ref);
    return BasicUtils.getValueWithinRange(window_width - dom_props.left, min, max);
  }
};

export default {
  getDOMProperties: getDOMProperties,
  checkWindowHeightOverflow: checkWindowHeightOverflow,
  checkWindowWidthOverflow: checkWindowWidthOverflow,
  calcHeight: calcHeight,
  calcWidth: calcWidth
};